
define('text!templates/app.html',[],function () { return '<div id="content"></div>';});

